module.exports = __webpack_public_path__ + "media/images/vod_icons/rowhouse-1bd362a700d7a50a88abe77aaa522398.svg";